/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationState } from './EvaluationState';
import {
    EvaluationStateFromJSON,
    EvaluationStateFromJSONTyped,
    EvaluationStateToJSON,
} from './EvaluationState';

/**
 * 
 * @export
 * @interface NumericDataPointDto
 */
export interface NumericDataPointDto {
    /**
     * 
     * @type {string}
     * @memberof NumericDataPointDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataPointDto
     */
    readonly creationTime: string;
    /**
     * 
     * @type {string}
     * @memberof NumericDataPointDto
     */
    creatorUserFullName?: string | null;
    /**
     * 
     * @type {EvaluationState}
     * @memberof NumericDataPointDto
     */
    evaluationOutcome: EvaluationState;
    /**
     * 
     * @type {number}
     * @memberof NumericDataPointDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericDataPointDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericDataPointDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericDataPointDto
     */
    actualValue?: number;
    /**
     * 
     * @type {number}
     * @memberof NumericDataPointDto
     */
    deviationValue: number;
    /**
     * 
     * @type {number}
     * @memberof NumericDataPointDto
     */
    upperWarningLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericDataPointDto
     */
    upperFailedLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericDataPointDto
     */
    lowerFailedLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericDataPointDto
     */
    lowerWarningLimit?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericDataPointDto
     */
    $type?: NumericDataPointDtoTypeEnum;
}


/**
 * @export
 */
export const NumericDataPointDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoNumericDataPointDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataPointDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericDataPointDtoTypeEnum = typeof NumericDataPointDtoTypeEnum[keyof typeof NumericDataPointDtoTypeEnum];


/**
 * Check if a given object implements the NumericDataPointDto interface.
 */
export function instanceOfNumericDataPointDto(value?: unknown): value is NumericDataPointDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericDataPointDtoTypeEnum)[0];
}

export function NumericDataPointDtoFromJSON(json: any): NumericDataPointDto {
    return NumericDataPointDtoFromJSONTyped(json, false);
}

export function NumericDataPointDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericDataPointDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'],
        'creatorUserFullName': !exists(json, 'creatorUserFullName') ? undefined : json['creatorUserFullName'],
        'evaluationOutcome': EvaluationStateFromJSON(json['evaluationOutcome']),
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'actualValue': !exists(json, 'actualValue') ? undefined : json['actualValue'],
        'deviationValue': json['deviationValue'],
        'upperWarningLimit': !exists(json, 'upperWarningLimit') ? undefined : json['upperWarningLimit'],
        'upperFailedLimit': !exists(json, 'upperFailedLimit') ? undefined : json['upperFailedLimit'],
        'lowerFailedLimit': !exists(json, 'lowerFailedLimit') ? undefined : json['lowerFailedLimit'],
        'lowerWarningLimit': !exists(json, 'lowerWarningLimit') ? undefined : json['lowerWarningLimit'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericDataPointDtoToJSON(value?: NumericDataPointDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'creatorUserFullName': value.creatorUserFullName,
        'evaluationOutcome': EvaluationStateToJSON(value.evaluationOutcome),
        'commentCount': value.commentCount,
        'lastComment': value.lastComment,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'actualValue': value.actualValue,
        'deviationValue': value.deviationValue,
        'upperWarningLimit': value.upperWarningLimit,
        'upperFailedLimit': value.upperFailedLimit,
        'lowerFailedLimit': value.lowerFailedLimit,
        'lowerWarningLimit': value.lowerWarningLimit,
        '$type': value.$type,
    });
}

